import { Button } from 'apps/shared/scripts/components';
import { ButtonTypes } from 'apps/shared/scripts/components/Button';

import messages from './messages.json';
import {
  footerClassName,
  primaryButtonClassName,
  secondaryButtonClassName,
} from './styles';

interface Props {
  isDisabled?: boolean;
  isSubmitting?: boolean;
  isSuccess?: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  primaryCtaLabel: string;
  secondaryCtaLabel?: string;
}

const Footer = ({
  isDisabled,
  isSubmitting,
  isSuccess,
  onCancel,
  onSubmit,
  primaryCtaLabel,
  secondaryCtaLabel,
}: Props) => {
  return (
    <div className={footerClassName}>
      <Button
        className={secondaryButtonClassName}
        onClick={onCancel}
        type={ButtonTypes.Button}
      >
        {secondaryCtaLabel ?? messages.cancelCtaLabel}
      </Button>
      <Button
        className={primaryButtonClassName}
        disabled={isDisabled || isSubmitting}
        loading={isSubmitting}
        success={isSuccess}
        onClick={onSubmit}
        type={ButtonTypes.Submit}
        bounce
      >
        {primaryCtaLabel}
      </Button>
    </div>
  );
};

Footer.displayName = 'Footer';

export default Footer;
